import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Select                   } from 'src/app/interface/select/select';
import { LoadingManager           } from 'src/app/managers/loading/loading.manager';
import { HandlerManager           } from 'src/app/managers/handler/handler.manager';
import { SessionManager           } from 'src/app/managers/session/session.manager';
import { User                     } from 'src/app/beans/login/user/user.bean';
import { Site                     } from 'src/app/beans/site/site.bean';
import { Service                  } from 'src/app/beans/service/service.bean';
import { MatSelectChange          } from '@angular/material/select';

@Component
({
  selector: 'service-select',
  templateUrl: './service.select.html',
  styleUrls: ['./service.select.scss']
})

export class ServiceSelect implements OnInit, Select 
{
  @Input( 'site' ) set _site( site: Site )
  {    
    if( site ) 
      this.init( site.id )
  }

  @Input() autoSelectFirst: boolean = false
  @Input() autoSelectId   : number  
  @Input() enabled        : number  = 1

  @Input() all            : any 

  @Output() change: EventEmitter<Service> = new EventEmitter<Service>()

  values      : Service[] = []
  currentValue: Service

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  ngOnInit() 
  {
    
  }

  async init( siteId: number )
  {
    this.values = await this.retriveValues( siteId )    

    if( this.values.length == 0 )
      this.change.emit( null )

    if(this.setSavedValue(JSON.parse(localStorage.getItem('service-select')))) {}
    else if( this.autoSelectFirst ) this.selectFirst()   
    if( this.autoSelectId ) this.selectById( this.autoSelectId )   
  }

  getSelectedValue()
  {
    return this.currentValue
  }

  setSelectedValue( value: Service ): void 
  {
    this.currentValue = value
    this.change.emit(value)
  }

  clearSelectedValue(): void 
  {
    this.setSelectedValue(undefined) 
  }

  async retriveValues( siteId: number )
  {

    const user  = this._session.user().get()

    if ( !User.isKind( user ) ) return // TODO handle user incorrect 

    this._loader.start()

    let response = await this._handler.service().list( ( user as User ).token, siteId, this.enabled )

    this._loader.stop()

    if ( !response ) return 

    const list = ( response as any ).list as Service[]

    this.values = list

    return list
  }

  selectFirst (): void 
  {
    if ( this.values && this.values.length > 0 ) {
      this.setSelectedValue(this.values[0]) 
    }
  }

  selectElement( el: Service ): void 
  {
    const find = this.searchElement( el )
    if ( find )  this.setSelectedValue(find) 
  }

  selectById( id: number ): void 
  { 
    const find = this.searchId( id )

    console.log( find )
    console.log( this.values );

    if ( find )  this.setSelectedValue(find) 
  }

  searchElement( el: Service ): Service
  {
    if ( !this.values ) return undefined
    
    return this.values.find ( ( service ) => service.id == el.id ) 
  }

  searchId( id: number ): Service
  {
    if ( !this.values ) return undefined

    return this.values.find ( ( service ) => service.id == id ) 
  }


  onChange(slChange: MatSelectChange) 
  {
    this.setSelectedValue(slChange.value)
    localStorage.setItem('service-select', JSON.stringify(slChange.value))

  }

  setSavedValue(device: Service)
  {
    var control = false
    if( this.values && device )
    {
      this.values.forEach(element => {
        if(element.id == device.id)
        { this.setSelectedValue(element)
          control = true
        }
      });
    }
    return control
  }
}
